import React from 'react';
import clsx from 'classnames';

export default function Button({ children, className = '', variant = 'royal', ...props }) {
  const variants = {
    royal: 'from-royal/90 to-royal/70 text-white shadow-glow',
    gold: 'from-gold to-amber-400 text-black',
    success: 'from-diceGreen to-emerald-500 text-white',
    danger: 'from-diceRed to-rose-500 text-white'
  };
  return (
    <button
      {...props}
      className={clsx(
        'rounded-full px-5 py-2 font-semibold bg-gradient-to-b border border-white/10',
        'transition-transform duration-150 active:scale-95 hover:scale-[1.03] shadow-soft',
        variants[variant],
        className
      )}
    >
      {children}
    </button>
  );
}

